import { render, staticRenderFns } from "./popContentMain.vue?vue&type=template&id=1c49c43e&scoped=true"
import script from "./popContentMain.vue?vue&type=script&setup=true&lang=js"
export * from "./popContentMain.vue?vue&type=script&setup=true&lang=js"
import style0 from "./popContentMain.vue?vue&type=style&index=0&id=1c49c43e&prod&lang=css"
import style1 from "./popContentMain.vue?vue&type=style&index=1&id=1c49c43e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49c43e",
  null
  
)

export default component.exports